import {OSM,XYZ} from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import {Map, View} from 'ol';
import {fromLonLat, toLonLat} from 'ol/proj';
import './style.css';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import {circular} from 'ol/geom/Polygon';
import Control from 'ol/control/Control';
import {Circle, Style, Fill, Stroke} from 'ol/style';
import Geocoder from 'ol-geocoder';

//------------------------------ SET UP LAYERS ------------------------

//set up map
const esriLayer = new TileLayer({
  visible:false,
 source: new XYZ({
        attributions: ["Powered by Esri. " ,
                               "Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community"],
         //sphericalMercator:true,  
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
             maxZoom:18,
 }),
});


const osmLayer = new TileLayer({
  name:"osmLayer",
   source: new OSM(),
   
 });

 //---------------There they aree.

const map = new Map({
  target: 'map-container',
  layers: [
    esriLayer,osmLayer
  ],
  view: new View({
    center: fromLonLat([-95, 40]),
    zoom: 3,
  }),
});

const campPointSource = new VectorSource();
const campPointStyle = new Style({
  image: new Circle({
    radius:6,
    stroke: new Stroke({color:'green', width:2,}),
  fill: new Fill({ color:'lightgreen', }),}),
  zindex: Infinity,

});
const campPointLayer = new VectorLayer({
  source:campPointSource,
  style:campPointStyle,
});

const recPointSource = new VectorSource();
const recPointStyle = new Style({
  image: new Circle({
    radius:6,
    stroke: new Stroke({color:'orangered', width:2,}),
  fill: new Fill({ color:'orange', }),}),
  zindex: Infinity,

});
const recPointLayer = new VectorLayer({
  source:recPointSource,
  style:recPointStyle,
});

const searchRadius = document.getElementById("searchRadius");

const pointSource = new VectorSource(); 
const circleSource = new VectorSource();

const pointStyle = new Style({
  image: new Circle({
    radius:5,
    stroke: new Stroke({color:'black', width:1,}),
  fill: new Fill({ color:'rgb(47,47,47)', }),}),
  zindex: Infinity,

});
const circleStyle = new Style({

stroke: new Stroke({color: 'red', width:3}),
fill: new Fill({color:'green'}),

});


const pointlayer = new VectorLayer({

source:pointSource,
style:pointStyle,

});

const circlelayer = new VectorLayer({
  source:circleSource,
})

//------------------------------------Layers----------------------------------- switchers.


const layerSwitcher = document.createElement('div');
const layerForm = document.getElementById("layerForm");
layerSwitcher.className = "ol-control ol-unslectable ";
layerSwitcher.id = "layerSwitcher";
layerSwitcher.innerHTML = "<button type='button' class='lsControl'>Select Layers</button>";

const showRec = document.getElementById('recVF');
const showCamp = document.getElementById('campVF');
const showOSM = document.getElementById('osmVF');
const showEsri = document.getElementById('esriVF');
function switchForm(){
layerForm.classList.toggle("lsfHidden");
}

function switchLayers(){
  
    recPointLayer.setVisible(showRec.checked);
  campPointLayer.setVisible(showCamp.checked);
  osmLayer.setVisible(showOSM.checked);
  esriLayer.setVisible(showEsri.checked);
}


layerSwitcher.addEventListener("click",switchForm);
showRec.addEventListener("change",switchLayers);
showCamp.addEventListener("change",switchLayers);
showOSM.addEventListener("change",switchLayers);
showEsri.addEventListener("change",switchLayers);


map.addControl( new Control({ element:layerSwitcher}));
map.addControl(new Control({element:layerForm}));

map.addLayer(campPointLayer);
map.addLayer(recPointLayer);
map.addLayer(circlelayer);
map.addLayer(pointlayer);

function findHome(){

  navigator.geolocation.getCurrentPosition(
  function (pos) {
    const latinput = document.getElementById("usrLat");
    const longinput = document.getElementById("usrLong");

    latinput.value = pos.coords.latitude;
    longinput.value = pos.coords.longitude;

    const coords = [pos.coords.longitude, pos.coords.latitude];
    const accuracy  = circular(coords, searchRadius.value*1609);
    circleSource.clear(true);
    circleSource.addFeatures([
      new Feature(accuracy.transform('EPSG:4326',map.getView().getProjection())),     
    ]);
    pointSource.clear(true);
    pointSource.addFeatures([
     new Feature (new Point(fromLonLat(coords))),
    ]);
    
    centerMap();

  },function(error){
    alert('ERROR: ${error.message');
  },{
    enableHighAccuracy:true,
  }

  
 
);

};

async function centerMap(){
  await new Promise(r => setTimeout(r,100));
     map.getView().fit(circleSource.getExtent(), {
    maxZoom: 14,
    duration: 500,
    padding: [25,25,25,25],
  });
 
 };
const locate = document.createElement('div');
locate.className = 'ol-control ol-unselectable locate';
locate.id = "locateControl";
locate.innerHTML = '<input type="button" value="◎">';


locate.addEventListener('click', function(){
  findHome();

});

function updatePos(evt){
  var coords = toLonLat(evt.coordinate);
var lat = coords[1];
var lon = coords[0];

var latinput = document.getElementById("usrLat");
var longinput = document.getElementById("usrLong");


latinput.value = lat;
longinput.value = lon;
 var accuracy = circular(coords,searchRadius.value*1609);
 circleSource.clear(true);
    circleSource.addFeatures([
      new Feature(accuracy.transform('EPSG:4326',map.getView().getProjection())),     
    ]);
    pointSource.clear(true);
    pointSource.addFeatures([
     new Feature (new Point(fromLonLat(coords))),
    ]);
centerMap();
}

map.on('click', function(evt){
 
updatePos(evt);
//if(!source.isEmpty()){
 //move the map to be centered on the clicked point.


//map.getView().animate({
//center: evt.coordinate,
//duration: 500,
//})}

});


map.addControl(
  new Control({
    element: locate,
  }));


  
  const geocoder = new Geocoder('nominatim',{
    placeholder: 'Search...',
    limit:5,
    tagetType:'text-input',
    countrycodes:'us',
    keepOpen: true,
  });
  
  geocoder.on('addresschosen', function(evt){
   updatePos(evt);
  
  });

  map.addControl(geocoder);




function movedefault(){

  var coords = [document.getElementById("usrLong").value,document.getElementById("usrLat").value];
  
  if(coords[0] == "" && coords[1] == ""){
      console.info("COORDS ARE empty");
    findHome();
  }else{
    console.info("Coords seem to be defined");
   var accuracy = circular(coords,searchRadius.value*1609);
   circleSource.clear(true);
      circleSource.addFeatures([
        new Feature(accuracy.transform('EPSG:4326',map.getView().getProjection())),     
      ]);
      pointSource.clear(true);
      pointSource.addFeatures([
       new Feature (new Point(fromLonLat(coords))),
      ]);

  centerMap();

    }
}

document.getElementById("showFormButton").addEventListener("click", movedefault);
document.getElementById("searchRadius").addEventListener("change",(e) => {
   
  var coords = [document.getElementById("usrLong").value,document.getElementById("usrLat").value];

  
  var accuracy = circular(coords,searchRadius.value*1609);
  circleSource.clear(true);
     circleSource.addFeatures([
       new Feature(accuracy.transform('EPSG:4326',map.getView().getProjection())),     
     ]);
     pointSource.clear(true);
     pointSource.addFeatures([
      new Feature (new Point(fromLonLat(coords))),
     ]);

 centerMap();
    }
);

document.getElementById("map-container").addEventListener("focus", centerMap());

movedefault();

const xhttp = new XMLHttpRequest();
xhttp.onload = function() {
    var data = JSON.parse(this.responseText);
    
    for(var i = 0; i < data.length; i++ ){
      
       var lat = data[i]["latitude"];
      var lon = data[i]["longitude"];

      if(data[i]["category"] == "camp"){
      campPointSource.addFeatures([
        new Feature ({
          geometry:new Point(fromLonLat([lon,lat])),
        url:data[i]["url"], 
        imglink: data[i]["imgLink"],
        ltype:"Overnight Camp",
        cost: "$"+data[i]["cost"],
      },
       
          ),
       ]); 
    }else{
      recPointSource.addFeatures([
        new Feature ({
          geometry:new Point(fromLonLat([lon,lat])),
        url:data[i]["url"], 
        imglink: data[i]["imgLink"],
        ltype:"Recreation Area",
        cost: "$"+data[i]["cost"],
      },
       
          ),
       ]); 
    }
    }
  }
xhttp.open("GET", "https://summercampcatalog.com/mappoints.php?loc=all", true);
xhttp.send();